function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import setupInterceptors from '@/services/setupInterceptors';
import axios from 'axios';
/* import { loginObj } from '@/services/base' */
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['chatbot']) {
  appApisGTW = axios.create({
    // baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8000')
    baseURL: 'https://itcm-inca-chatbotmngt-877374341472.us-central1.run.app'.replace('{PORT}', ':8000')
  });
} else {
  appApisGTW = axios.create({
    // baseURL: 'https://dev-itcbi-matilliondev-run-usct1-temp-qmuzefzuga-uc.a.run.app'.replace('{PORT}', ':8000')
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000') //process.env.VUE_APP_CR_CHATBOT_MNGMT // process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var MODULE = '/api/chatbotmngt';
var CONTROLLER = '/search-engine';
export default {
  getAll: function getAll() {
    tasks.lockScreen.lock();
    return appApisGTW.get(MODULE + CONTROLLER + "").then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  get: function get(id) {
    tasks.lockScreen.lock();
    return appApisGTW.get(MODULE + CONTROLLER + "/".concat(id)).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  create: function create(data) {
    var body = _objectSpread({}, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(MODULE + CONTROLLER + "", body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  update: function update(id, data) {
    var body = _objectSpread({}, data);
    tasks.lockScreen.lock();
    return appApisGTW.put(MODULE + CONTROLLER + "/".concat(id), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  delete: function _delete(id) {
    tasks.lockScreen.lock();
    return appApisGTW.delete(MODULE + CONTROLLER + "/".concat(id)).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};